//  NODE MODULES

import React from 'react';

const Footer = () => {
    return (
        <footer>
            <p>&copy; 2018 - OneThirdLocal - Created by: Maggie Deuitch, Christopher Arsenault & Ben Kelly</p>
        </footer>
    );
};

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer.js